<template>
  <div class="sales-pipeline-editor-item" :class="{'editor-view': edit_mode}">
    <v-row>

      <v-col class="py-0 icon-col" md="2">
        <div class="icon"></div>
      </v-col>

      <v-col class="py-0" md="4">
        <span class="caption">Name</span>
        <span class="label font-weight-medium" v-if="!edit_mode">{{ fields.name }}</span>

        <div class="edit-group" v-if="edit_mode">
          <TextFieldCustom :value="fields.name" @input="onInput($event, 'name')" class="label-input" />
          <ToolTip>
            <template v-slot:title>
              Tooltip Title
            </template>
            <p>
              Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
            </p>
            <p>
              Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen. Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr bekannt ist dieser: The
            </p>
          </ToolTip>
        </div>


        <span class="caption">Phasendauer</span>
        <span class="label label-phase font-weight-medium" v-if="!edit_mode">{{ formatInterval(fields.duration, 'DHM') }}</span>
        <div class="edit-group" v-if="edit_mode">

          <DurationInput :value="fields.duration" :limits="'99:24:60'" :format="'DHM'" @input="onInput($event, 'duration')" />
          <!-- <TextFieldCustom :value="fields.duration" @input="onInput($event, 'duration')" class="label-input" /> -->

          <ToolTip>
            <template v-slot:title>
              Tooltip Title
            </template>
            <p>
              Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
            </p>
            <p>
              Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen. Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr bekannt ist dieser: The
            </p>
          </ToolTip>
        </div>
      </v-col>

      <v-col class="py-0" md="4">
        <span class="caption">Nachfassintervall</span>
        <span class="label font-weight-medium" v-if="!edit_mode">{{ fields.interval }}</span>
        <div class="edit-group" v-if="edit_mode">
          <v-select
                  :items="interval_types"
                  :value="fields.interval"
                  @input="onInput($event, 'interval')"
                  label="Intervall"
                  outlined
                  class="pr-1"
                />
          <ToolTip>
            <template v-slot:title>
              Tooltip Title
            </template>
            <p>
              Dies ist ein Typoblindtext. An ihm kann man sehen, ob alle Buchstaben da sind und wie sie aussehen.
            </p>
            <p>
              Manchmal benutzt man Worte wie Hamburgefonts, Rafgenduks oder Handgloves, um Schriften zu testen. Manchmal Sätze, die alle Buchstaben des Alphabets enthalten - man nennt diese Sätze »Pangrams«. Sehr bekannt ist dieser: The
            </p>
          </ToolTip>
        </div>

      </v-col>

      <v-col class="py-0" md="2">
        <div class="edit-mode-buttons with-placeholder" v-if="!edit_mode">
          <v-btn @click="onEdit" icon>
            <EditIcon />
          </v-btn>
        </div>
        <div class="edit-mode-buttons" v-if="edit_mode">
          <v-btn @click="onSave" icon>
            <AcceptIcon/>
          </v-btn>
          <v-btn @click="onDiscard" icon>
            <DiscardIcon/>
          </v-btn>
          <v-btn @click="onDelete" icon>
            <DeleteIconLight/>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {reactive, watch, toRefs} from '@vue/composition-api'
import EditIcon from "@/components/icons/Edit2Icon";
import AcceptIcon from "@/components/icons/AcceptIcon";
import DiscardIcon from "@/components/icons/DiscardIcon";
import DeleteIconLight from "@/components/icons/DeleteIconLight";
import TextFieldCustom from '@/components/form/TextFieldCustom';
import DurationInput from '@/components/form/DurationInput';
import ToolTip from "@/components/info/ToolTip";

export default {

  name: 'SalesPipelineEditorItem',
  components: {
    EditIcon,
    AcceptIcon,
    DiscardIcon,
    DeleteIconLight,
    TextFieldCustom,
    DurationInput,
    ToolTip
  },
  props:{
    value: Object
  },

  setup(props, {emit}){
    const fields = reactive({
      id: props.value.id,
      name: props.value.name,
      duration: props.value.duration,
      interval: props.value.interval,
      edit_mode: (props.value.edit_mode) ? props.value.edit_mode : false
    });

    const {edit_mode} = toRefs(fields);

    //update props
    //watch deep on nested objects
    watch(() => props.value, () => {
      // console.log('watcher');
      for (const [key, value] of Object.entries(props.value))
      {
        fields[key] = (value) ? value : '';
      }
    },{deep:true});

    //flat clone fields
    let temp_fields = {...fields};

    const interval_types = [
      {text: 'täglich', value: 'täglich'},
      {text: 'wöchentlich', value: 'wöchentlich'},
      {text: 'monatlich', value: 'monatlich'}
    ]

    function formatInterval(interval_str, units){
      let arr_units = units.split('');
      let arr_interval = interval_str.split(':');

      return arr_interval[0] + arr_units[0] + ':' + arr_interval[1] + arr_units[1] + ':' + arr_interval[2] + arr_units[2];
    }

    //store input in temp val
    function onInput(val, type){
      temp_fields[type] = val;
    }

    function onEdit(){
      edit_mode.value = true;
    }

    function onSave(){

      //set temp fields
      for (const [key, value] of Object.entries(temp_fields))
      {
        fields[key] = value;
      }

      edit_mode.value = false;

      emit('input', fields);
      emit('save', fields);
    }

    function onDiscard(){
      edit_mode.value = false;

      //discard temp_field content
      temp_fields = {...fields};

      emit('discard', props.value);
    }

    function onDelete(){
      edit_mode.value = false;

      //discard temp_field content
      temp_fields = {...fields};

      emit('delete', props.value.id);
    }

    return {edit_mode, fields, interval_types, formatInterval, onInput,
      onEdit, onSave, onDiscard, onDelete
    };
  }
}
</script>

<style lang="scss" scoped>
  .sales-pipeline-editor-item {
    position: relative;
    padding: $spacer 0 $spacer - 4px;

    // Circle icon
    &.first {
      .icon-col::before {
        display: none;
      }
    }

    &.last {
      border-bottom: none;

      .icon-col::after {
        bottom: -48px;
        background: linear-gradient(180deg, rgba(map-get($grey, 'lighten-blue-1') ,1) 10%, rgba(map-get($grey, 'lighten-blue-1') ,0) 100%);
        height: calc(50% + 48px);
      }
    }

    .icon-col {
      position: relative;

      &::before,
      &::after {
        position: absolute;
        z-index: 1;
        background-color: map-get($grey, 'lighten-blue-1');
        content: '';
        display: block;
        width: 3px;
        height: calc(50% + 16px);
      }

      &::before {
        top: -16px;
      }

      &::after {
        bottom: -13px;
      }

      .icon {
        position: relative;
        z-index: 2;
        background-color: white;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        border: 2px solid map-get($grey, 'lighten-blue-1');
        border-radius: 50%;
        width: 48px;
        height: 48px;
      }
    }

    // Edit grup
    .edit-group {
      position: relative;
      display: flex;
      margin-bottom: $spacer*.75;
      padding-top: 4px;

      .tooltip {
        position: absolute;
        top: -8px;
        right: -24px;
      }
    }

    // Content
    .caption {
      display: block;
      color: map-get($grey, 'darken-1');
      font-size: 14px !important;
      line-height: 17px;
      margin-bottom: $spacer/4;
    }

    .label {
      display: block;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: $spacer/2;
    }

    .label-phase {
      letter-spacing: 0.25em;
    }

    // Button group
    .edit-mode-buttons {
      flex: 0 0 160px;
      width: 160px;

      &.with-placeholder {
        margin-left: 50px;
      }

      button {
        background: transparent;
        box-shadow: none;
        padding: 8px 0;
        min-width: 0;

        @media screen and (min-width: 1200px) {
          padding: 8px;
        }

        &:before {
          display: none;
        }

        &:hover {
          svg {
            .a, .b {
              stroke: #73998E;
            }
          }
        }

        + button {
          margin-left: 12px;
        }

        .v-ripple__container {
          display: none;
        }
      }
    }

    // Edit view
    &.editor-view {
      border-top: 1px dashed map-get($green, 'darken-1');
      border-bottom: 1px dashed map-get($green, 'darken-1');

      &.first {
        border-top: none;
      }

      // Change circle color
      .icon-col .icon {
        border-color: map-get($green, 'darken-1');
      }

      // Change position of button group
      .edit-mode-buttons {
        position: absolute;
        right: 0;
        bottom: $spacer*1.5;
      }
    }
  }
</style>

<!-- icons and other external components -->
<style lang="scss">
  .sales-pipeline-editor-item{
    .icon-col{
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .edit-group{
      // Remove label form select item
      .v-text-field {
        .v-label {
          display: none;
        }

        &--outlined legend {
          display: none;
        }
      }
    }
  }
</style>


